"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LOCAL_STORAGE_KEY_SKYRA = void 0;
exports.sendVisSkyraUndersøkelseEvent = sendVisSkyraUndersøkelseEvent;
exports.slettSkyraCookies = slettSkyraCookies;
exports.useSkyraUndersøkelse = useSkyraUndersøkelse;
var _react = require("react");
var _utils = require("./utils");
const LOCAL_STORAGE_KEY_SKYRA = exports.LOCAL_STORAGE_KEY_SKYRA = 'skyra-undersøkelse-id';
const VIS_SKYRA_UNDERSØKELSE_EVENT_NAME = 'brukerinnsikt-vis-skyra-undersøkelse';
const TOP_TASK_T004 = 't004-top-task';
/**
 * Setter inn et script som laster ned og viser en Skyra undersøkelse.
 * For å vise en undersøkelse, kall sendVisSkyraUndersøkelseEvent med en id.
 * Id-en blir lagt til i local storage slik at den persisterer økter og ulike applikasjoner.
 * Hvis det allerede finnes en id i local storage vil hooken vise denne Skyra undersøkelsen når den mounter.
 */
function useSkyraUndersøkelse({
  id
} = {}) {
  const [skyraUndersøkelseId, setSkyraUndersøkelseId] = (0, _react.useState)(() => {
    const initialId = id || TOP_TASK_T004;
    localStorage.setItem(LOCAL_STORAGE_KEY_SKYRA, initialId);
    return initialId;
  });
  (0, _react.useEffect)(() => {
    window.addEventListener(VIS_SKYRA_UNDERSØKELSE_EVENT_NAME, handleEvent);
    return () => window.removeEventListener(VIS_SKYRA_UNDERSØKELSE_EVENT_NAME, handleEvent);
  }, []);
  function handleEvent(event) {
    visSkyraUndersøkelse(event.detail.id);
  }
  (0, _react.useEffect)(() => {
    if (!skyraUndersøkelseId) return;
    const skyraScriptAlreadyAdded = !!document.querySelector(`script[data-testid="skyra-script"]`);
    if (skyraScriptAlreadyAdded) {
      injectSurvey();
    } else {
      const skyraScript = document.createElement('script');
      skyraScript.setAttribute('data-testid', 'skyra-script');
      skyraScript.src = _utils.skyraScriptURL;
      // Vi kan kjøre scriptet etter siden er ferdig lastet for litt bedre ytelse
      skyraScript.defer = true;
      skyraScript.onload = injectSurvey;
      document.body.appendChild(skyraScript);
    }
    function injectSurvey() {
      window.skyra?.inject({
        slug: `skatteetaten/${skyraUndersøkelseId}`
      });
    }
  }, [skyraUndersøkelseId]);
  function visSkyraUndersøkelse(id) {
    localStorage.setItem(LOCAL_STORAGE_KEY_SKYRA, id);
    setSkyraUndersøkelseId(id);
  }
  function fjernSkyraUndersøkelse() {
    document.querySelectorAll('skyra-survey').forEach(element => {
      element.remove();
    });
    localStorage.removeItem(LOCAL_STORAGE_KEY_SKYRA);
    setSkyraUndersøkelseId('');
  }
  function hentAktivSkyraUndersøkelseId() {
    return localStorage.getItem(LOCAL_STORAGE_KEY_SKYRA) || '';
  }
  return {
    visSkyraUndersøkelse,
    fjernSkyraUndersøkelse,
    hentAktivSkyraUndersøkelseId
  };
}

/**
 * @deprecated
 * Bruk visSkyraUndersøkelse i stedet
 */
function sendVisSkyraUndersøkelseEvent(id) {
  window.dispatchEvent(new CustomEvent(VIS_SKYRA_UNDERSØKELSE_EVENT_NAME, {
    detail: {
      id
    }
  }));
}
function slettSkyraCookies() {
  const cookies = document.cookie.split(';');
  cookies.forEach(cookie => {
    const [name] = cookie.trim().split('=');
    if (name.startsWith('skyra')) {
      // sett expire til fortiden for å slette cookien
      document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
    }
  });
}